'use strict';

var Actions = require('../actions/ImageServerActionCreators'),
    { get: get, post, del } = require('../utils/APIUtils');

var ImageAPI = {
  addToGrabbag(uuid, stampId) {
    post('/api/images/saved', { uuid, stampId }, Actions.handleAddToGrabbag, uuid, stampId);
  },

  requestGrabbagImagesPage(tab, url) {
    url = url || '/api/images/' + tab;
    get(url, Actions.handleGrabbagImagesPage, tab);
  },

  removeFromGrabbag(uuid) {
    del('/api/images/saved/' + uuid, { uuid }, Actions.handleRemoveFromGrabbag, uuid);
  },

  removeStampletItem(uuid) {
    del('/api/images/stamplet/' + uuid, { uuid }, Actions.handleRemoveStampletItem, uuid);
  },

  requestImageUsedInStampsPage(imageUuid, url) {
    url = url || '/api/images/' + imageUuid + '/stamps';
    get(url, Actions.handleImageUsedInStampsPage, imageUuid);
  }
};

module.exports = ImageAPI;


/** WEBPACK FOOTER **
 ** ./api/ImageAPI.js
 **/